import React from "react";

export const getTypeSvg = (name, color) => {
  switch (name) {
    case "icon-default-type-1":
      return (
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 2.22222H6.595C6.37 1.87556 6.06 1.57778 5.685 1.35111L6.5 0.626667L5.795 0L4.71 0.964444C4.48 0.915556 4.245 0.888889 4 0.888889C3.755 0.888889 3.52 0.915556 3.295 0.964444L2.205 0L1.5 0.626667L2.31 1.35111C1.94 1.57778 1.63 1.87556 1.405 2.22222H0V3.11111H1.045C1.02 3.25778 1 3.40444 1 3.55556V4H0V4.88889H1V5.33333C1 5.48444 1.02 5.63111 1.045 5.77778H0V6.66667H1.405C1.925 7.46222 2.89 8 4 8C5.11 8 6.075 7.46222 6.595 6.66667H8V5.77778H6.955C6.98 5.63111 7 5.48444 7 5.33333V4.88889H8V4H7V3.55556C7 3.40444 6.98 3.25778 6.955 3.11111H8V2.22222ZM6 4V5.33333C6 5.43111 5.985 5.54222 5.965 5.64444L5.915 5.93333L5.73 6.22222C5.37 6.77333 4.71 7.11111 4 7.11111C3.29 7.11111 2.63 6.76889 2.27 6.22222L2.085 5.93778L2.035 5.64889C2.015 5.54667 2 5.43556 2 5.33333V3.55556C2 3.45333 2.015 3.34222 2.035 3.24444L2.085 2.95556L2.27 2.66667C2.42 2.43556 2.63 2.23556 2.875 2.08444L3.16 1.91111L3.53 1.83111C3.685 1.79556 3.845 1.77778 4 1.77778C4.16 1.77778 4.315 1.79556 4.475 1.83111L4.815 1.90222L5.12 2.08889C5.37 2.24 5.575 2.43556 5.725 2.67111L5.915 2.96L5.965 3.24889C5.985 3.34667 6 3.45778 6 3.55556V4ZM3 4.88889H5V5.77778H3V4.88889ZM3 3.11111H5V4H3V3.11111Z"
            fill={color}
          />
        </svg>
      );
    case "icon-default-type-2":
      return (
        <svg
          width="5"
          height="9"
          viewBox="0 0 5 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.99799 9H1.49824L1.99799 5.5H0.248882C-0.190893 5.5 0.0839662 5.125 0.093961 5.11C0.738631 3.97 1.70814 2.27 3.00247 0H3.50222L3.00247 3.5H4.75658C4.95648 3.5 5.06642 3.595 4.95648 3.83C2.98248 7.275 1.99799 9 1.99799 9Z"
            fill={color}
          />
        </svg>
      );
    case "icon-default-type-3":
      return (
        <svg
          width="12"
          height="7"
          viewBox="0 0 12 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 1.995V3.5H11.6667V0H8.16667V1.16667H9.67167L7.07 3.76833C6.8425 3.99583 6.475 3.99583 6.2475 3.76833L5.565 3.08583C4.8825 2.40333 3.77417 2.40333 3.09167 3.08583L0 6.1775L0.8225 7L3.90833 3.91417C4.13583 3.68667 4.50333 3.68667 4.73083 3.91417L5.41333 4.59667C6.09583 5.27917 7.20417 5.27917 7.88667 4.59667L10.5 1.995Z"
            fill={color}
          />
        </svg>
      );
    case "icon-default-type-4":
      return (
        <svg
          width="9"
          height="9"
          viewBox="0 0 9 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.85 0.9V4.05H1.4265L1.161 4.3155L0.9 4.5765V0.9H5.85ZM6.3 0H0.45C0.2025 0 0 0.2025 0 0.45V5.78432C0 6.14068 0.430857 6.31914 0.682843 6.06716L1.8 4.95H6.3C6.5475 4.95 6.75 4.7475 6.75 4.5V0.45C6.75 0.2025 6.5475 0 6.3 0ZM8.55 1.8H7.65V5.85H1.8V6.75C1.8 6.9975 2.0025 7.2 2.25 7.2H7.2L8.31716 8.31716C8.56914 8.56914 9 8.39068 9 8.03431V2.25C9 2.0025 8.7975 1.8 8.55 1.8Z"
            fill={color}
          />
        </svg>
      );
    case "icon-default-type-5":
      return (
        <svg
          width="9"
          height="9"
          viewBox="0 0 9 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.05 7.2H4.95V6.3H4.05V7.2ZM4.5 0C2.016 0 0 2.016 0 4.5C0 6.984 2.016 9 4.5 9C6.984 9 9 6.984 9 4.5C9 2.016 6.984 0 4.5 0ZM4.5 8.1C2.5155 8.1 0.9 6.4845 0.9 4.5C0.9 2.5155 2.5155 0.9 4.5 0.9C6.4845 0.9 8.1 2.5155 8.1 4.5C8.1 6.4845 6.4845 8.1 4.5 8.1ZM4.5 1.8C3.5055 1.8 2.7 2.6055 2.7 3.6H3.6C3.6 3.105 4.005 2.7 4.5 2.7C4.995 2.7 5.4 3.105 5.4 3.6C5.4 4.5 4.05 4.3875 4.05 5.85H4.95C4.95 4.8375 6.3 4.725 6.3 3.6C6.3 2.6055 5.4945 1.8 4.5 1.8Z"
            fill={color}
          />
        </svg>
      );
    case "icon-default-type-6":
      return (
        <svg
          width="7"
          height="9"
          viewBox="0 0 7 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 8.55C2 8.7975 2.225 9 2.5 9H4.5C4.775 9 5 8.7975 5 8.55V8.1H2V8.55ZM3.5 0C1.57 0 0 1.413 0 3.15C0 4.221 0.595 5.1615 1.5 5.733V6.75C1.5 6.9975 1.725 7.2 2 7.2H5C5.275 7.2 5.5 6.9975 5.5 6.75V5.733C6.405 5.1615 7 4.221 7 3.15C7 1.413 5.43 0 3.5 0ZM4.925 4.995L4.5 5.265V6.3H2.5V5.265L2.075 4.995C1.4 4.572 1 3.8835 1 3.15C1 1.908 2.12 0.9 3.5 0.9C4.88 0.9 6 1.908 6 3.15C6 3.8835 5.6 4.572 4.925 4.995Z"
            fill={color}
          />
        </svg>
      );
    case "icon-default-type-7":
      return (
        <svg
          width="7"
          height="7"
          viewBox="0 0 7 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.3 0.636364H5.95V0H5.25V0.636364H1.75V0H1.05V0.636364H0.7C0.315 0.636364 0 0.922727 0 1.27273V6.36364C0 6.71364 0.315 7 0.7 7H6.3C6.685 7 7 6.71364 7 6.36364V1.27273C7 0.922727 6.685 0.636364 6.3 0.636364ZM6.3 6.36364H0.7V2.86364H6.3V6.36364ZM6.3 2.22727H0.7V1.27273H6.3V2.22727Z"
            fill={color}
          />
        </svg>
      );
    case "icon-default-type-8":
      return (
        <svg
          width="7"
          height="7"
          viewBox="0 0 7 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.61111 0.777778V0.388889C6.61111 0.175 6.43611 0 6.22222 0H5.44444C5.23056 0 5.05556 0.175 5.05556 0.388889V0.777778H4.66667V2.33333C4.66667 2.54722 4.84167 2.72222 5.05556 2.72222H5.44444V5.44444C5.44444 5.87222 5.09444 6.22222 4.66667 6.22222C4.23889 6.22222 3.88889 5.87222 3.88889 5.44444V1.55556C3.88889 0.696111 3.19278 0 2.33333 0C1.47389 0 0.777778 0.696111 0.777778 1.55556V4.27778H0.388889C0.175 4.27778 0 4.45278 0 4.66667V6.22222H0.388889V6.61111C0.388889 6.825 0.563889 7 0.777778 7H1.55556C1.76944 7 1.94444 6.825 1.94444 6.61111V6.22222H2.33333V4.66667C2.33333 4.45278 2.15833 4.27778 1.94444 4.27778H1.55556V1.55556C1.55556 1.12778 1.90556 0.777778 2.33333 0.777778C2.76111 0.777778 3.11111 1.12778 3.11111 1.55556V5.44444C3.11111 6.30389 3.80722 7 4.66667 7C5.52611 7 6.22222 6.30389 6.22222 5.44444V2.72222H6.61111C6.825 2.72222 7 2.54722 7 2.33333V0.777778H6.61111Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-1":
      return (
        <svg
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 0.933333C6.72273 0.933333 8.25909 1.92733 9.00909 3.5C8.25909 5.07267 6.72273 6.06667 5 6.06667C3.27727 6.06667 1.74091 5.07267 0.990909 3.5C1.74091 1.92733 3.27727 0.933333 5 0.933333ZM5 0C2.72727 0 0.786364 1.45133 0 3.5C0.786364 5.54867 2.72727 7 5 7C7.27273 7 9.21364 5.54867 10 3.5C9.21364 1.45133 7.27273 0 5 0ZM5 2.33333C5.62727 2.33333 6.13636 2.856 6.13636 3.5C6.13636 4.144 5.62727 4.66667 5 4.66667C4.37273 4.66667 3.86364 4.144 3.86364 3.5C3.86364 2.856 4.37273 2.33333 5 2.33333ZM5 1.4C3.87273 1.4 2.95455 2.34267 2.95455 3.5C2.95455 4.65733 3.87273 5.6 5 5.6C6.12727 5.6 7.04545 4.65733 7.04545 3.5C7.04545 2.34267 6.12727 1.4 5 1.4Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-2":
      return (
        <svg
          width="6"
          height="8"
          viewBox="0 0 6 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.14286 0H0.857143C0.385714 0 0 0.4 0 0.888889V8L3 6.66667L6 8V0.888889C6 0.4 5.61429 0 5.14286 0Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-3":
      return (
        <svg
          width="6"
          height="9"
          viewBox="0 0 6 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 0C1.34143 0 0 1.4085 0 3.15C0 5.5125 3 9 3 9C3 9 6 5.5125 6 3.15C6 1.4085 4.65857 0 3 0ZM0.857143 3.15C0.857143 1.908 1.81714 0.9 3 0.9C4.18286 0.9 5.14286 1.908 5.14286 3.15C5.14286 4.446 3.90857 6.3855 3 7.596C2.10857 6.3945 0.857143 4.4325 0.857143 3.15Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-4":
      return (
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0833 7.33366V6.41699L6.18749 4.12533V1.60449C6.18749 1.22408 5.88041 0.916992 5.49999 0.916992C5.11957 0.916992 4.81249 1.22408 4.81249 1.60449V4.12533L0.916656 6.41699V7.33366L4.81249 6.18783V8.70866L3.66666 9.39616V10.0837L5.49999 9.62533L7.33332 10.0837V9.39616L6.18749 8.70866V6.18783L10.0833 7.33366Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-5":
      return (
        <svg
          width="8"
          height="9"
          viewBox="0 0 8 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.6 0L0 1.35V4.0905C0 6.363 1.5345 8.4825 3.6 9C5.6655 8.4825 7.2 6.363 7.2 4.0905V1.35L3.6 0ZM6.3 4.0905C6.3 5.8905 5.1525 7.5555 3.6 8.064C2.0475 7.5555 0.9 5.895 0.9 4.0905V1.9395L3.6 0.9855L6.3 1.9395V4.0905ZM2.169 3.8655L1.53 4.5L3.123 6.093L5.67 3.546L5.0355 2.9115L3.1275 4.8195L2.169 3.8655Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-6":
      return (
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.41671 2.91634H4.58337V4.58301H2.91671V5.41634H4.58337V7.08301H5.41671V5.41634H7.08337V4.58301H5.41671V2.91634ZM5.00004 0.833008C2.70004 0.833008 0.833374 2.69967 0.833374 4.99967C0.833374 7.29967 2.70004 9.16634 5.00004 9.16634C7.30004 9.16634 9.16671 7.29967 9.16671 4.99967C9.16671 2.69967 7.30004 0.833008 5.00004 0.833008ZM5.00004 8.33301C3.16254 8.33301 1.66671 6.83717 1.66671 4.99967C1.66671 3.16217 3.16254 1.66634 5.00004 1.66634C6.83754 1.66634 8.33337 3.16217 8.33337 4.99967C8.33337 6.83717 6.83754 8.33301 5.00004 8.33301Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-7":
      return (
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.91667 6.91667H1.08333V1.08333H4V0.25H1.08333C0.620833 0.25 0.25 0.625 0.25 1.08333V6.91667C0.25 7.375 0.620833 7.75 1.08333 7.75H6.91667C7.375 7.75 7.75 7.375 7.75 6.91667V4H6.91667V6.91667ZM4.83333 0.25V1.08333H6.32917L2.23333 5.17917L2.82083 5.76667L6.91667 1.67083V3.16667H7.75V0.25H4.83333Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-8":
      return (
        <svg
          width="10"
          height="9"
          viewBox="0 0 10 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.00004 7.19551L7.57504 8.74967L6.89171 5.82051L9.16671 3.84967L6.17087 3.59551L5.00004 0.833008L3.82921 3.59551L0.833374 3.84967L3.10837 5.82051L2.42504 8.74967L5.00004 7.19551Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-9":
      return (
        <svg
          width="9"
          height="9"
          viewBox="0 0 9 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.983 7.3485C8.6175 6.57 9 5.58 9 4.5C9 2.016 6.984 0 4.5 0C2.016 0 0 2.016 0 4.5C0 6.984 2.016 9 4.5 9C5.58 9 6.57 8.6175 7.3485 7.983C7.47 7.884 7.587 7.776 7.6995 7.6635C7.713 7.65 7.722 7.6365 7.731 7.6275C7.821 7.5375 7.9065 7.443 7.983 7.3485ZM4.5 8.1C2.5155 8.1 0.9 6.4845 0.9 4.5C0.9 2.5155 2.5155 0.9 4.5 0.9C6.4845 0.9 8.1 2.5155 8.1 4.5C8.1 5.3325 7.8165 6.093 7.3395 6.705L6.696 6.0615C7.0065 5.6205 7.191 5.085 7.191 4.5045C7.191 3.015 5.9805 1.8045 4.491 1.8045C3.0015 1.8045 1.791 3.015 1.791 4.5045C1.791 5.994 3.0015 7.2045 4.491 7.2045C5.076 7.2045 5.6205 7.0155 6.0615 6.696L6.7005 7.335C6.093 7.8165 5.3325 8.1 4.5 8.1ZM5.364 4.7295C5.4405 4.4325 5.373 4.1085 5.1435 3.8745L5.1345 3.8655C4.788 3.519 4.2345 3.5145 3.8835 3.8475C3.879 3.852 3.87 3.8565 3.861 3.8655C3.51 4.2165 3.51 4.788 3.861 5.139L3.87 5.148C4.104 5.3775 4.4325 5.4495 4.7295 5.3685L5.409 6.048C5.139 6.21 4.8285 6.309 4.491 6.309C3.4965 6.309 2.691 5.5035 2.691 4.509C2.691 3.5145 3.4965 2.709 4.491 2.709C5.4855 2.709 6.291 3.5145 6.291 4.509C6.291 4.8375 6.1965 5.1435 6.039 5.409L5.364 4.7295Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-10":
      return (
        <svg
          width="8"
          height="6"
          viewBox="0 0 8 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.33329 2.66667V0H4.99996V1H2.99996V0H0.666626V2.66667H2.99996V1.66667H3.66663V5H4.99996V6H7.33329V3.33333H4.99996V4.33333H4.33329V1.66667H4.99996V2.66667H7.33329ZM2.33329 2H1.33329V0.666667H2.33329V2ZM5.66663 4H6.66663V5.33333H5.66663V4ZM5.66663 0.666667H6.66663V2H5.66663V0.666667Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-11":
      return (
        <svg
          width="6"
          height="8"
          viewBox="0 0 6 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.80634 4.07121C5.21745 2.54085 3.12072 2.45833 3.62709 0.234071C3.6646 0.0690334 3.4883 -0.058496 3.34577 0.0277739C1.98421 0.830459 1.00523 2.43958 1.82667 4.54757C1.89419 4.72011 1.69164 4.88139 1.54536 4.76887C0.86645 4.255 0.795184 3.51608 0.855197 2.98721C0.877703 2.79216 0.622644 2.69839 0.513869 2.85968C0.25881 3.24977 0 3.87991 0 4.82888C0.142533 6.92937 1.91669 7.57452 2.55434 7.65703C3.4658 7.77331 4.45228 7.60452 5.16119 6.95562C5.94137 6.23171 6.22644 5.07644 5.80634 4.07121ZM2.32554 5.95789C2.86566 5.82661 3.14323 5.43652 3.21824 5.09144C3.34202 4.55507 2.85816 4.02995 3.18448 3.18225C3.30826 3.88366 4.41102 4.32251 4.41102 5.08769C4.44102 6.03666 3.41329 6.8506 2.32554 5.95789Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-12":
      return (
        <svg
          width="7"
          height="7"
          viewBox="0 0 7 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 1.25C0.5 0.8375 0.8375 0.5 1.25 0.5C1.6625 0.5 2 0.8375 2 1.25C2 1.6625 1.6625 2 1.25 2C0.8375 2 0.5 1.6625 0.5 1.25ZM1.25 4.25C1.6625 4.25 2 3.9125 2 3.5C2 3.0875 1.6625 2.75 1.25 2.75C0.8375 2.75 0.5 3.0875 0.5 3.5C0.5 3.9125 0.8375 4.25 1.25 4.25ZM3.5 2C3.9125 2 4.25 1.6625 4.25 1.25C4.25 0.8375 3.9125 0.5 3.5 0.5C3.0875 0.5 2.75 0.8375 2.75 1.25C2.75 1.6625 3.0875 2 3.5 2ZM5.75 2.75C5.3375 2.75 5 3.0875 5 3.5C5 3.9125 5.3375 4.25 5.75 4.25C6.1625 4.25 6.5 3.9125 6.5 3.5C6.5 3.0875 6.1625 2.75 5.75 2.75ZM5.7425 5C5.465 5 5.22875 5.15 5.0975 5.375H4.145C4.0175 5.15 3.7775 5 3.5 5C3.2225 5 2.98625 5.15 2.855 5.375H2.15375L3.305 4.22375C3.36875 4.23875 3.4325 4.25 3.5 4.25C3.9125 4.25 4.25 3.9125 4.25 3.5C4.25 3.4325 4.23875 3.36875 4.22375 3.30875L5.55875 1.97375C5.61875 1.98875 5.6825 2 5.75 2C6.1625 2 6.5 1.6625 6.5 1.25C6.5 0.8375 6.1625 0.5 5.75 0.5C5.3375 0.5 5 0.8375 5 1.25C5 1.3175 5.01125 1.38125 5.02625 1.44125L3.69125 2.77625C3.63125 2.76125 3.5675 2.75 3.5 2.75C3.0875 2.75 2.75 3.0875 2.75 3.5C2.75 3.5675 2.76125 3.63125 2.77625 3.69125L1.44125 5.02625C1.38125 5.01125 1.3175 5 1.25 5C0.8375 5 0.5 5.3375 0.5 5.75C0.5 6.1625 0.8375 6.5 1.25 6.5C1.5275 6.5 1.76375 6.35 1.895 6.125H2.85875C2.98625 6.35 3.22625 6.5 3.50375 6.5C3.78125 6.5 4.0175 6.35 4.14875 6.125H5.105C5.2325 6.35 5.4725 6.5 5.75 6.5C6.1625 6.5 6.5 6.1625 6.5 5.75C6.4925 5.3375 6.155 5 5.7425 5Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-13":
      return (
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 0C1.792 0 0 1.792 0 4C0 6.208 1.792 8 4 8C6.208 8 8 6.208 8 4C8 1.792 6.208 0 4 0ZM4.4 6H3.6V5.2H4.4V6ZM4.4 4.4H3.6V2H4.4V4.4Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-14":
      return (
        <svg
          width="6"
          height="8"
          viewBox="0 0 6 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 0L0 1.45455V3.63636C0 5.65455 1.28 7.54182 3 8C4.72 7.54182 6 5.65455 6 3.63636V1.45455L3 0ZM3 3.99636H5.33333C5.15667 5.49455 4.24 6.82909 3 7.24727V4H0.666667V1.92727L3 0.796364V3.99636Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-15":
      return (
        <svg
          width="9"
          height="7"
          viewBox="0 0 9 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.25 1.78625L7.72125 1.2575L6.21 2.95625L3.5625 0.5L0.75 3.31625L1.3125 3.87875L3.615 1.5725L5.71125 3.515L5.0625 4.24625L3.5625 2.74625L0.75 5.5625L1.3125 6.125L3.5625 3.87125L5.0625 5.37125L6.25875 4.025L7.72125 5.37875L8.25 4.85L6.7575 3.4625L8.25 1.78625Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-16":
      return (
        <svg
          width="9"
          height="7"
          viewBox="0 0 9 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.25 1.78625L7.72125 1.2575L6.21 2.95625L3.5625 0.5L0.75 3.31625L1.3125 3.87875L3.615 1.5725L5.71125 3.515L5.0625 4.24625L3.5625 2.74625L0.75 5.5625L1.3125 6.125L3.5625 3.87125L5.0625 5.37125L6.25875 4.025L7.72125 5.37875L8.25 4.85L6.7575 3.4625L8.25 1.78625Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-17":
      return (
        <svg
          width="9"
          height="9"
          viewBox="0 0 9 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.12087 0.75C1.84387 0.75 0 2.598 0 4.875C0 7.152 1.84387 9 4.12087 9C6.402 9 8.25 7.152 8.25 4.875C8.25 2.598 6.402 0.75 4.12087 0.75ZM5.48212 6.81787L3.7125 5.04413V2.8125H4.5375V4.70587L6.06787 6.23625L5.48212 6.81787Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-18":
      return (
        <svg
          width="7"
          height="7"
          viewBox="0 0 7 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.44444 5.05556L3.88889 3.5V2.26333C4.34 2.1 4.66667 1.67222 4.66667 1.16667C4.66667 0.521111 4.14556 0 3.5 0C2.85444 0 2.33333 0.521111 2.33333 1.16667C2.33333 1.67222 2.66 2.1 3.11111 2.26333V3.5L1.55556 5.05556H0V7H1.94444V5.81389L3.5 4.18056L5.05556 5.81389V7H7V5.05556H5.44444Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-19":
      return (
        <svg
          width="6"
          height="7"
          viewBox="0 0 6 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.75 0.7C3.2935 0.7 4.55 1.9565 4.55 3.5C4.55 5.0435 3.2935 6.3 1.75 6.3C1.631 6.3 1.512 6.293 1.3965 6.2755C2.065 5.5195 2.45 4.5325 2.45 3.5C2.45 2.4675 2.065 1.4805 1.3965 0.7245C1.512 0.707 1.631 0.7 1.75 0.7ZM1.75 0C1.113 0 0.5145 0.175 0 0.4725C1.0465 1.078 1.75 2.205 1.75 3.5C1.75 4.795 1.0465 5.922 0 6.5275C0.5145 6.825 1.113 7 1.75 7C3.682 7 5.25 5.432 5.25 3.5C5.25 1.568 3.682 0 1.75 0Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-20":
      return (
        <svg
          width="7"
          height="7"
          viewBox="0 0 7 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.125 0.125H0.875C0.4625 0.125 0.125 0.4625 0.125 0.875V6.125C0.125 6.5375 0.4625 6.875 0.875 6.875H6.125C6.5375 6.875 6.875 6.5375 6.875 6.125V0.875C6.875 0.4625 6.5375 0.125 6.125 0.125ZM6.125 6.125H0.875V0.875H6.125V6.125ZM4.235 3.60875L3.20375 4.93625L2.46875 4.05125L1.4375 5.375H5.5625L4.235 3.60875Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-21":
      return (
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.00004 0.833008C2.70004 0.833008 0.833374 2.69967 0.833374 4.99967C0.833374 7.29967 2.70004 9.16634 5.00004 9.16634C7.30004 9.16634 9.16671 7.29967 9.16671 4.99967C9.16671 2.69967 7.30004 0.833008 5.00004 0.833008ZM1.66671 4.99967C1.66671 4.74551 1.70004 4.49551 1.75421 4.25801L3.74587 6.24967V6.66634C3.74587 7.12467 4.12087 7.49967 4.57921 7.49967V8.30384C2.94171 8.09551 1.66671 6.69551 1.66671 4.99967ZM7.45421 7.24967C7.34587 6.91217 7.03754 6.66634 6.66254 6.66634H6.24587V5.41634C6.24587 5.18717 6.05837 4.99967 5.82921 4.99967H3.32921V4.16634H4.16254C4.39171 4.16634 4.57921 3.97884 4.57921 3.74967V2.91634H5.41254C5.87087 2.91634 6.24587 2.54134 6.24587 2.08301V1.91217C7.46671 2.40384 8.33337 3.60384 8.33337 4.99967C8.33337 5.86634 7.99587 6.65801 7.45421 7.24967Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-22":
      return (
        <svg
          width="7"
          height="7"
          viewBox="0 0 7 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.97123 1.02812C5.33646 0.39375 4.46529 0 3.49781 0C1.56285 0 0 1.56625 0 3.5C0 5.43375 1.56285 7 3.49781 7C5.13071 7 6.49218 5.88438 6.8818 4.375H5.97123C5.61226 5.39437 4.6404 6.125 3.49781 6.125C2.04878 6.125 0.871169 4.94812 0.871169 3.5C0.871169 2.05188 2.04878 0.875 3.49781 0.875C4.22452 0.875 4.87242 1.17688 5.34522 1.65375L3.93558 3.0625H7V0L5.97123 1.02812Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-23":
      return (
        <svg
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.99997 5.39173C5.69033 5.39173 6.24997 4.32095 6.24997 3.00007C6.24997 1.67918 5.69033 0.608398 4.99997 0.608398C4.30961 0.608398 3.74997 1.67918 3.74997 3.00007C3.74997 4.32095 4.30961 5.39173 4.99997 5.39173Z"
            fill={color}
          />
          <path
            d="M6.87496 2.99967C6.87496 3.40384 6.77912 4.73301 5.61246 5.70801C5.93746 5.83718 6.29162 5.91634 6.66662 5.91634C8.27496 5.91634 9.58329 4.60801 9.58329 2.99967C9.58329 1.39134 8.27496 0.0830078 6.66662 0.0830078C6.29162 0.0830078 5.93746 0.162174 5.61246 0.291341C6.77912 1.26634 6.87496 2.59551 6.87496 2.99967Z"
            fill={color}
          />
          <path
            d="M3.33329 5.91634C3.70829 5.91634 4.06246 5.83718 4.38746 5.70801C4.13329 5.49551 3.92913 5.26218 3.76663 5.02884C3.62913 5.06218 3.48329 5.08301 3.33329 5.08301C2.18329 5.08301 1.24996 4.14967 1.24996 2.99967C1.24996 1.84967 2.18329 0.916341 3.33329 0.916341C3.48329 0.916341 3.62913 0.937175 3.76663 0.970508C3.92913 0.737175 4.13329 0.503841 4.38746 0.291341C4.06246 0.162174 3.70829 0.0830078 3.33329 0.0830078C1.72496 0.0830078 0.416626 1.39134 0.416626 2.99967C0.416626 4.60801 1.72496 5.91634 3.33329 5.91634Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-24":
      return (
        <svg
          width="7"
          height="9"
          viewBox="0 0 7 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.375 5.625L5.95625 6.20625C5.59625 6.84 4.7075 7.34625 3.875 7.47V4.125H5V3.375H3.875V2.9325C4.31 2.775 4.625 2.3625 4.625 1.875C4.625 1.25625 4.11875 0.75 3.5 0.75C2.88125 0.75 2.375 1.25625 2.375 1.875C2.375 2.3625 2.69 2.775 3.125 2.9325V3.375H2V4.125H3.125V7.47C2.2925 7.34625 1.40375 6.84 1.04375 6.20625L1.625 5.625L0.125 4.5V5.625C0.125 7.08 1.97 8.25 3.5 8.25C5.03 8.25 6.875 7.08 6.875 5.625V4.5L5.375 5.625ZM3.5 1.5C3.70625 1.5 3.875 1.66875 3.875 1.875C3.875 2.08125 3.70625 2.25 3.5 2.25C3.29375 2.25 3.125 2.08125 3.125 1.875C3.125 1.66875 3.29375 1.5 3.5 1.5Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-25":
      return (
        <svg
          width="9"
          height="9"
          viewBox="0 0 9 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.74994 6L8.24994 4.5L6.74994 3V4.125H4.85244C4.72494 2.9625 4.00494 1.98 2.99994 1.48125C2.98494 0.86625 2.48994 0.375 1.87494 0.375C1.25244 0.375 0.749939 0.8775 0.749939 1.5C0.749939 2.1225 1.25244 2.625 1.87494 2.625C2.23119 2.625 2.54244 2.45625 2.74869 2.1975C3.46119 2.5875 3.97494 3.28875 4.09494 4.125H2.93244C2.77494 3.69 2.36244 3.375 1.87494 3.375C1.25244 3.375 0.749939 3.8775 0.749939 4.5C0.749939 5.1225 1.25244 5.625 1.87494 5.625C2.36244 5.625 2.77494 5.31 2.93244 4.875H4.09494C3.97494 5.71125 3.46119 6.4125 2.75244 6.8025C2.54244 6.54375 2.23119 6.375 1.87494 6.375C1.25244 6.375 0.749939 6.8775 0.749939 7.5C0.749939 8.1225 1.25244 8.625 1.87494 8.625C2.48994 8.625 2.98494 8.13375 2.99619 7.51875C4.00119 7.02 4.72119 6.0375 4.84869 4.875H6.74994V6Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-26":
      return (
        <svg
          width="7"
          height="7"
          viewBox="0 0 7 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.3 1.47368H4.9V0.736842C4.9 0.327895 4.5885 0 4.2 0H2.8C2.4115 0 2.1 0.327895 2.1 0.736842V1.47368H0.7C0.3115 1.47368 0.0035 1.80158 0.0035 2.21053L0 6.26316C0 6.67211 0.3115 7 0.7 7H6.3C6.6885 7 7 6.67211 7 6.26316V2.21053C7 1.80158 6.6885 1.47368 6.3 1.47368ZM4.2 1.47368H2.8V0.736842H4.2V1.47368Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-27":
      return (
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.05628 4.392C7.07273 4.264 7.08507 4.136 7.08507 4C7.08507 3.864 7.07273 3.736 7.05628 3.608L7.92396 2.948C8.00209 2.888 8.02265 2.78 7.97331 2.692L7.15086 1.308C7.11385 1.244 7.04395 1.208 6.96993 1.208C6.94525 1.208 6.92058 1.212 6.90002 1.22L5.87608 1.62C5.66224 1.46 5.43196 1.328 5.18111 1.228L5.02485 0.168C5.01251 0.072 4.92616 0 4.82335 0H3.17847C3.07566 0 2.9893 0.072 2.97697 0.168L2.8207 1.228C2.56986 1.328 2.33957 1.464 2.12574 1.62L1.1018 1.22C1.07712 1.212 1.05245 1.208 1.02778 1.208C0.957871 1.208 0.887963 1.244 0.850953 1.308L0.0285106 2.692C-0.0249481 2.78 -0.00027482 2.888 0.0778572 2.948L0.945534 3.608C0.929085 3.736 0.916749 3.868 0.916749 4C0.916749 4.132 0.929085 4.264 0.945534 4.392L0.0778572 5.052C-0.00027482 5.112 -0.0208359 5.22 0.0285106 5.308L0.850953 6.692C0.887963 6.756 0.957871 6.792 1.03189 6.792C1.05656 6.792 1.08124 6.788 1.1018 6.78L2.12574 6.38C2.33957 6.54 2.56986 6.672 2.8207 6.772L2.97697 7.832C2.9893 7.928 3.07566 8 3.17847 8H4.82335C4.92616 8 5.01251 7.928 5.02485 7.832L5.18111 6.772C5.43196 6.672 5.66224 6.536 5.87608 6.38L6.90002 6.78C6.92469 6.788 6.94936 6.792 6.97404 6.792C7.04395 6.792 7.11385 6.756 7.15086 6.692L7.97331 5.308C8.02265 5.22 8.00209 5.112 7.92396 5.052L7.05628 4.392ZM6.24206 3.708C6.25851 3.832 6.26263 3.916 6.26263 4C6.26263 4.084 6.2544 4.172 6.24206 4.292L6.18449 4.744L6.55048 5.024L6.9946 5.36L6.70674 5.844L6.18449 5.64L5.75682 5.472L5.38672 5.744C5.2099 5.872 5.0413 5.968 4.8727 6.036L4.4368 6.208L4.37101 6.66L4.28876 7.2H3.71305L3.63492 6.66L3.56913 6.208L3.13323 6.036C2.95641 5.964 2.79192 5.872 2.62743 5.752L2.25322 5.472L1.81732 5.644L1.29507 5.848L1.00722 5.364L1.45134 5.028L1.81732 4.748L1.75975 4.296C1.74742 4.172 1.73919 4.08 1.73919 4C1.73919 3.92 1.74742 3.828 1.75975 3.708L1.81732 3.256L1.45134 2.976L1.00722 2.64L1.29507 2.156L1.81732 2.36L2.24499 2.528L2.61509 2.256C2.79192 2.128 2.96052 2.032 3.12912 1.964L3.56501 1.792L3.63081 1.34L3.71305 0.8H4.28465L4.36278 1.34L4.42858 1.792L4.86447 1.964C5.0413 2.036 5.20579 2.128 5.37028 2.248L5.74449 2.528L6.18038 2.356L6.70263 2.152L6.99049 2.636L6.55048 2.976L6.18449 3.256L6.24206 3.708ZM4.00091 2.4C3.09211 2.4 2.35602 3.116 2.35602 4C2.35602 4.884 3.09211 5.6 4.00091 5.6C4.90971 5.6 5.64579 4.884 5.64579 4C5.64579 3.116 4.90971 2.4 4.00091 2.4ZM4.00091 4.8C3.54856 4.8 3.17847 4.44 3.17847 4C3.17847 3.56 3.54856 3.2 4.00091 3.2C4.45325 3.2 4.82335 3.56 4.82335 4C4.82335 4.44 4.45325 4.8 4.00091 4.8Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-28":
      return (
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.99666 0.666992C2.15666 0.666992 0.666656 2.16033 0.666656 4.00033C0.666656 5.84033 2.15666 7.33366 3.99666 7.33366C5.83999 7.33366 7.33332 5.84033 7.33332 4.00033C7.33332 2.16033 5.83999 0.666992 3.99666 0.666992ZM6.30666 2.66699H5.32332C5.21666 2.25033 5.06332 1.85033 4.86332 1.48033C5.47666 1.69033 5.98666 2.11699 6.30666 2.66699ZM3.99999 1.34699C4.27666 1.74699 4.49332 2.19033 4.63666 2.66699H3.36332C3.50666 2.19033 3.72332 1.74699 3.99999 1.34699ZM1.41999 4.66699C1.36666 4.45366 1.33332 4.23033 1.33332 4.00033C1.33332 3.77033 1.36666 3.54699 1.41999 3.33366H2.54666C2.51999 3.55366 2.49999 3.77366 2.49999 4.00033C2.49999 4.22699 2.51999 4.44699 2.54666 4.66699H1.41999ZM1.69332 5.33366H2.67666C2.78332 5.75033 2.93666 6.15033 3.13666 6.52033C2.52332 6.31033 2.01332 5.88699 1.69332 5.33366ZM2.67666 2.66699H1.69332C2.01332 2.11366 2.52332 1.69033 3.13666 1.48033C2.93666 1.85033 2.78332 2.25033 2.67666 2.66699ZM3.99999 6.65366C3.72332 6.25366 3.50666 5.81033 3.36332 5.33366H4.63666C4.49332 5.81033 4.27666 6.25366 3.99999 6.65366ZM4.77999 4.66699H3.21999C3.18999 4.44699 3.16666 4.22699 3.16666 4.00033C3.16666 3.77366 3.18999 3.55033 3.21999 3.33366H4.77999C4.80999 3.55033 4.83332 3.77366 4.83332 4.00033C4.83332 4.22699 4.80999 4.44699 4.77999 4.66699ZM4.86332 6.52033C5.06332 6.15033 5.21666 5.75033 5.32332 5.33366H6.30666C5.98666 5.88366 5.47666 6.31033 4.86332 6.52033ZM5.45332 4.66699C5.47999 4.44699 5.49999 4.22699 5.49999 4.00033C5.49999 3.77366 5.47999 3.55366 5.45332 3.33366H6.57999C6.63332 3.54699 6.66666 3.77033 6.66666 4.00033C6.66666 4.23033 6.63332 4.45366 6.57999 4.66699H5.45332Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-29":
      return (
        <svg
          width="6"
          height="6"
          viewBox="0 0 6 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 6L2.565 5.56839C1.02 4.04142 0 3.03433 0 1.79837C0 0.791281 0.726 0 1.65 0C2.172 0 2.673 0.26485 3 0.683379C3.327 0.26485 3.828 0 4.35 0C5.274 0 6 0.791281 6 1.79837C6 3.03433 4.98 4.04142 3.435 5.57166L3 6Z"
            fill={color}
          />
        </svg>
      );
    case "issue-other-type-30":
      return (
        <svg
          width="6"
          height="6"
          viewBox="0 0 6 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.6 0.705882L3.2 0H0V6H0.8V3.52941H2.8L3.2 4.23529H6V0.705882H3.6ZM5.2 3.52941H3.6L3.2 2.82353H0.8V0.705882H2.8L3.2 1.41176H5.2V3.52941Z"
            fill={color}
          />
        </svg>
      );
    default:
      return <></>;
  }
};

export const getGeneralSvg = (name) => {
  switch (name) {
    case "linkDoc":
      return (
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="14" rx="3" fill="#D4E1FF" />
          <g clip-path="url(#clip0_115_1341)">
            <path
              d="M12.1185 7.47486C11.0254 6.34786 9.56868 5.72724 8.01653 5.72724L8.00806 5.72738L8.00404 5.72724C8.0021 5.72724 8.00016 5.72738 7.99822 5.72753C7.99628 5.72768 7.99435 5.72783 7.99241 5.72783C6.44944 5.73414 5.0021 6.35374 3.91474 7.47486L9.3688 6.19261C10.3252 6.43902 11.2015 6.94638 11.9146 7.68163C11.9704 7.73935 12.0615 7.73964 12.1176 7.68252M12.1185 7.47486C12.1743 7.53243 12.1739 7.62539 12.1176 7.68252M12.1185 7.47486L12.1902 7.40523C12.1902 7.40523 12.1902 7.40523 12.1902 7.40522M12.1185 7.47486L12.1902 7.40522M12.1176 7.68252L12.1889 7.75261C12.1889 7.75264 12.1889 7.75267 12.1888 7.7527C12.0933 7.84982 11.9377 7.84923 11.8428 7.75126C11.1806 7.06851 10.3757 6.58627 9.49687 6.33134M12.1176 7.68252L9.49687 6.33134M9.49687 6.33134C9.79186 6.68254 9.97064 7.13831 9.97064 7.63626C9.97064 8.74203 9.0906 9.64542 8.00404 9.64542C6.91748 9.64542 6.03743 8.74203 6.03743 7.63626C6.03743 7.14346 6.21242 6.69159 6.50201 6.34174C5.63658 6.5991 4.84389 7.07742 4.19043 7.75123C4.19043 7.75124 4.19042 7.75125 4.19041 7.75125L4.15746 7.78525L9.49687 6.33134ZM12.1902 7.40522C11.0785 6.25907 9.59608 5.62724 8.01653 5.62724L8.00967 5.62735C8.00955 5.62735 8.00944 5.62735 8.00934 5.62735M12.1902 7.40522L8.00934 5.62735M8.00934 5.62735C8.00796 5.6273 8.00605 5.62724 8.00404 5.62724C7.99812 5.62724 7.99275 5.62766 7.99099 5.62779L7.99067 5.62782C7.9906 5.62782 7.99053 5.62783 7.99047 5.62783C6.42083 5.63466 4.94846 6.26541 3.84295 7.40524L3.84293 7.40526L3.80994 7.43929C3.80993 7.43931 3.80992 7.43932 3.80991 7.43933C3.71618 7.53597 3.71698 7.691 3.81134 7.78677L3.81143 7.78686C3.85865 7.83467 3.92108 7.85918 3.98366 7.85918C4.04682 7.85918 4.11002 7.83423 4.15741 7.7853L8.00934 5.62735ZM8.00404 9.1517C8.81754 9.1517 9.48347 8.47386 9.48347 7.63626C9.48347 6.80015 8.81986 6.1233 8.00805 6.12096C8.00798 6.12096 8.00777 6.12096 8.00737 6.12097L8.00452 6.12109L8.00404 9.1517ZM8.00404 9.1517C7.19054 9.1517 6.5246 8.47386 6.5246 7.63626C6.5246 6.80257 7.18435 6.12764 7.99278 6.1214L8.00404 9.1517Z"
              fill="#4B6FFC"
              stroke="#4B6FFC"
              stroke-width="0.2"
            />
          </g>
          <defs>
            <clipPath id="clip0_115_1341">
              <rect
                width="10.24"
                height="10.1818"
                fill="white"
                transform="translate(2.56006 1.90936)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case "download":
      return (
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="14" rx="3" fill="#4B6FFC" />
          <path
            d="M7.49749 7.93879C7.66702 8.10646 7.94025 8.10584 8.10934 7.93706L9.40921 6.63721C9.57867 6.46775 9.57867 6.19299 9.40921 6.02353C9.23977 5.85407 8.96501 5.85407 8.79554 6.02353L8.23645 6.5826V4.43394C8.23645 4.19426 8.04217 4 7.80252 4C7.56286 4 7.36858 4.19426 7.36858 4.43394V6.58262L6.80949 6.02355C6.64002 5.85407 6.36526 5.85407 6.19582 6.02355C6.02636 6.19303 6.02636 6.46778 6.19582 6.63722C6.2153 6.65673 7.478 7.91944 7.49749 7.93879Z"
            fill="white"
          />
          <path
            d="M10.6303 8.7998H5.36973C5.16554 8.7998 5 8.92163 5 9.07193V9.72768C5 9.87797 5.16554 9.9998 5.36973 9.9998H10.6303C10.8345 9.9998 11 9.87797 11 9.72768V9.07193C11 8.92163 10.8345 8.7998 10.6303 8.7998Z"
            fill="white"
          />
        </svg>
      );
    case "subtask":
      return (
        <svg
          width="12"
          height="11"
          viewBox="0 0 12 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.65875 0H3.32553C2.2962 0 1.46667 0.777348 1.46667 1.72107V9.29807C1.46667 10.2418 2.2962 11 3.32553 11H8.65875C9.68806 11 10.5333 10.2418 10.5333 9.29807V1.72107C10.5333 0.777348 9.68806 0 8.65875 0ZM10 9.29807C10 9.97223 9.39399 10.5111 8.65875 10.5111H3.32553C2.59027 10.5111 2 9.97223 2 9.29807V1.72107C2 1.04691 2.59027 0.488877 3.32553 0.488877H8.65875C9.39399 0.488877 10 1.04689 10 1.72107V9.29807Z"
            fill="#4B6FFC"
          />
          <path d="M8.4 1.22266H3.6V1.71155H8.4V1.22266Z" fill="#4B6FFC" />
          <path
            d="M3.6 3.66699H3.33333C3.18607 3.66699 3.06666 3.77643 3.06666 3.91144V4.40032C3.06666 4.5353 3.18605 4.64477 3.33333 4.64477H3.6C3.74726 4.64477 3.86667 4.53533 3.86667 4.40032V3.91142C3.86667 3.77643 3.74726 3.66699 3.6 3.66699Z"
            fill="#4B6FFC"
          />
          <path
            d="M3.6 5.86621H3.33333C3.18607 5.86621 3.06666 5.97565 3.06666 6.11066V6.59954C3.06666 6.73452 3.18605 6.84399 3.33333 6.84399H3.6C3.74726 6.84399 3.86667 6.73455 3.86667 6.59954V6.11064C3.86667 5.97565 3.74726 5.86621 3.6 5.86621Z"
            fill="#4B6FFC"
          />
          <path
            d="M3.6 8.06641H3.33333C3.18607 8.06641 3.06666 8.17585 3.06666 8.31086V8.79973C3.06666 8.93472 3.18605 9.04418 3.33333 9.04418H3.6C3.74726 9.04418 3.86667 8.93474 3.86667 8.79973V8.31083C3.86667 8.17585 3.74726 8.06641 3.6 8.06641Z"
            fill="#4B6FFC"
          />
          <path
            d="M8.93332 3.91113H4.66666V4.40003H8.93332V3.91113Z"
            fill="#4B6FFC"
          />
          <path
            d="M8.93332 6.11133H4.66666V6.60023H8.93332V6.11133Z"
            fill="#4B6FFC"
          />
          <path
            d="M8.93332 8.31152H4.66666V8.80042H8.93332V8.31152Z"
            fill="#4B6FFC"
          />
        </svg>
      );
    case "leaf":
      return (
        <svg
          width="10"
          height="12"
          viewBox="0 0 10 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.02413 3.71325C9.02225 3.70013 9.02 3.6885 9.017 3.67763L9.01737 3.6795C9.00575 3.62925 8.98213 3.58613 8.94913 3.55125L5.94913 0.55125C5.91463 0.518625 5.8715 0.495 5.8235 0.483375L5.82162 0.483C5.8115 0.48 5.7995 0.47775 5.78713 0.475875H5.786C5.77625 0.47325 5.76387 0.470625 5.7515 0.46875H5.75H1.25C1.09475 0.46875 0.96875 0.59475 0.96875 0.75V11.25C0.96875 11.4053 1.09475 11.5312 1.25 11.5312H8.75C8.90525 11.5312 9.03125 11.4053 9.03125 11.25V3.75C9.02938 3.73575 9.02675 3.72338 9.02375 3.71138L9.02413 3.71325ZM8.07087 3.46875H6.03125V1.42913L8.07087 3.46875ZM1.53125 10.9688V1.03125H5.46875V3.75C5.46875 3.90525 5.59475 4.03125 5.75 4.03125H8.46875V10.9688H1.53125Z"
            fill="#4B6FFC"
          />
        </svg>
      );
    case "expand":
      return (
        <svg
          width="7"
          height="5"
          viewBox="0 0 7 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 1L3.45385 4L6.5 1"
            stroke="#959595"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "fold":
      return (
        <svg
          width="5"
          height="8"
          viewBox="0 0 5 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.999634 6.99982L3.99963 4.04597L0.999634 0.999818"
            stroke="#959595"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "folder":
      return (
        <svg
          width="13"
          height="11"
          viewBox="0 0 13 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.625 1.4375V9.5625H11.375V3.0625H6.16687L4.53863 1.4375H1.625ZM1.21875 0.625H4.87337L6.50325 2.25H11.7812C11.889 2.25 11.9923 2.2928 12.0685 2.36899C12.1447 2.44517 12.1875 2.54851 12.1875 2.65625V9.96875C12.1875 10.0765 12.1447 10.1798 12.0685 10.256C11.9923 10.3322 11.889 10.375 11.7812 10.375H1.21875C1.11101 10.375 1.00767 10.3322 0.931488 10.256C0.855301 10.1798 0.8125 10.0765 0.8125 9.96875V1.03125C0.8125 0.923506 0.855301 0.820175 0.931488 0.743988C1.00767 0.667801 1.11101 0.625 1.21875 0.625Z"
            fill="#666666"
          />
        </svg>
      );
    default:
      return <></>;
  }
};
